"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Retrieve = void 0;
var expression_1 = require("./expression");
var util_1 = require("../util/util");
var builder_1 = require("./builder");
var Retrieve = /** @class */ (function (_super) {
    __extends(Retrieve, _super);
    function Retrieve(json) {
        var _this = _super.call(this, json) || this;
        _this.datatype = json.dataType;
        _this.templateId = json.templateId;
        _this.codeProperty = json.codeProperty;
        _this.codes = (0, builder_1.build)(json.codes);
        _this.dateProperty = json.dateProperty;
        _this.dateRange = (0, builder_1.build)(json.dateRange);
        return _this;
    }
    Retrieve.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var retrieveDetails, resolvedCodes, _a, records;
            var _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        retrieveDetails = __assign(__assign({ datatype: this.datatype }, (this.codeProperty ? { codeProperty: this.codeProperty } : {})), (this.dateProperty ? { dateProperty: this.dateProperty } : {}));
                        if (!this.codes) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.codes.execute(ctx)];
                    case 1:
                        resolvedCodes = _c.sent();
                        if (resolvedCodes == null) {
                            return [2 /*return*/, []];
                        }
                        retrieveDetails.codes = resolvedCodes;
                        _c.label = 2;
                    case 2:
                        if (!this.dateRange) return [3 /*break*/, 4];
                        _a = retrieveDetails;
                        return [4 /*yield*/, this.dateRange.execute(ctx)];
                    case 3:
                        _a.dateRange = _c.sent();
                        _c.label = 4;
                    case 4:
                        if (this.templateId) {
                            retrieveDetails.templateId = this.templateId;
                        }
                        return [4 /*yield*/, ctx.findRecords(this.templateId != null ? this.templateId : this.datatype, retrieveDetails)];
                    case 5:
                        records = _c.sent();
                        if (retrieveDetails.codes) {
                            records = records.filter(function (r) { return _this.recordMatchesCodesOrVS(r, retrieveDetails.codes); });
                        }
                        if (retrieveDetails.dateRange && this.dateProperty) {
                            records = records.filter(function (r) { var _a; return (_a = retrieveDetails.dateRange) === null || _a === void 0 ? void 0 : _a.includes(r.getDateOrInterval(_this.dateProperty)); });
                        }
                        if (Array.isArray(records)) {
                            (_b = ctx.evaluatedRecords).push.apply(_b, records);
                        }
                        else {
                            ctx.evaluatedRecords.push(records);
                        }
                        return [2 /*return*/, records];
                }
            });
        });
    };
    Retrieve.prototype.recordMatchesCodesOrVS = function (record, codes) {
        var _this = this;
        if ((0, util_1.typeIsArray)(codes)) {
            return codes.some(function (c) { return c.hasMatch(record.getCode(_this.codeProperty)); });
        }
        else {
            return codes.hasMatch(record.getCode(this.codeProperty));
        }
    };
    return Retrieve;
}(expression_1.Expression));
exports.Retrieve = Retrieve;
//# sourceMappingURL=external.js.map